<template>
    <div class="mb-3" :class="bsClass">
        <label :for="name" class="form-label" v-if="!labelHidden">
            {{ label }}
            <span class="text-danger" v-if="required"> *</span>
        </label>
        <multiselect
            v-model="colorSelected"
            :options="colors"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="true"
            :placeholder="placeholder"
            label="name"
            track-by="id"
            :preselect-first="false"
            :hide-selected="false"
            select-label=""
            selected-label="Sélectionné"
            deselect-label=""
        >
            <template #option="{ option }">
                <div v-html="customLabel(option)"></div>
            </template>
            <template #singleLabel="{ option }">
                <div v-html="customLabel(option)"></div>
            </template>
        </multiselect>
        <span class="error-message" v-html="errorMessage()"></span>
        <span class="form-text text-muted" v-if="informationContent !== null">
            {{ informationContent }}
        </span>
    </div>
</template>

<script>
import { APPOINTMENT_TYPES, findAppointmentType } from '../Constants/appointmentTypes.js'

export default {
    name: "GoogleCalendarColorSelector",
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        labelHidden: {
            type: Boolean,
            required: false,
            default: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        informationContent: {
            type: String,
            required: false,
            default: null
        },
        reference: {
            type: String,
            required: false,
            default: 'color-select'
        },
        colorPreSelected: {
            type: Number,
            required: false,
            default: null
        },
        errors: {
            required: true
        },
        bsClass: {
            type: String,
            required: false,
            default: "col-md-12"
        }
    },
    data() {
        return {
            // Types de RDV : libellés et couleurs dans Constants/appointmentTypes.js
            colorSelected: (({ id, name, color }) => ({ id, name, color }))(findAppointmentType('7')),
            colors: APPOINTMENT_TYPES.map(({ id, name, color }) => ({ id, name, color })),
            loading: false,
        }
    },
    methods: {
        clearErrors() {
            if (this.hasError) {
                this.errors[this.name] = null;
            }
        },
        errorClassObject() {
            return {
                "is-invalid": this.hasError
            };
        },
        errorMessage() {
            if (this.hasError) {
                return this.errors[this.name][0];
            }
        },
        customLabel(color) {
            return `
                <div style="display: flex; align-items: center;">
                    <span style="background-color: ${color.color}; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;"></span>
                    <span>${color.name}</span>
                </div>
            `;
        }
    },
    computed: {
        hasError() {
            return (
                this.errors &&
                this.errors[this.name] &&
                this.errors[this.name].length > 0
            );
        }
    },
    watch: {
        colorSelected(newVal) {
            if (newVal === null) {
                this.$emit("update:field", null);
            } else {
                this.clearErrors();
                this.$emit("update:field", this.colorSelected);
            }
        },
        colorPreSelected: {
            immediate: true,
            handler(newVal) {
                if (newVal !== null) {
                    const selectedColor = this.colors.find(color => color.id === newVal.toString());
                    if (selectedColor) {
                        this.colorSelected = {
                            id: selectedColor.id,
                            name: selectedColor.name,
                            color: selectedColor.color
                        };
                        this.$emit("update:field", this.colorSelected);
                    }
                }
            }
        }
    }
}
</script>
